module.exports = __webpack_public_path__ + "static/flags/it-d93743a7d71c6aac467b4270be045268.svg";